import api from '../../api'

// initial state
const state = {
  selectedItem: {}
}

// getters
const getters = {
  getSelectedItem: state => state.selectedItem
}

// actions
const actions = {
  getAllOrders ({commit}) {
    if (!state.all.length) {
      api.get('orders', orders => {
        commit('setOrders', orders)
      })
    }
  }
}

// mutations
const mutations = {
  setSelectedItem (state, payLoad) {
    state.selectedItem = payLoad
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/general.js